import React, { useCallback, useContext, useState } from "react"

const ModeContext = React.createContext(null)

export const ModeContextProvider = ({ children }) => {
  const [mode, setMode] = useState("deck") //  prints, deck
  const resetMode = useCallback(() => setMode("pick"), [])
  return (
    <ModeContext.Provider
      value={{
        mode,
        setMode,
        resetMode,
      }}
    >
      {children}
    </ModeContext.Provider>
  )
}

export const useModeContext = () => {
  const value = useContext(ModeContext)
  if (!value) {
    throw new Error("called useModeCOntext outside of provider")
  }
  return value
}
